import { render, staticRenderFns } from "./proceedingsTab.vue?vue&type=template&id=8061fa8e"
import script from "./proceedingsTab.vue?vue&type=script&lang=js"
export * from "./proceedingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8061fa8e')) {
      api.createRecord('8061fa8e', component.options)
    } else {
      api.reload('8061fa8e', component.options)
    }
    module.hot.accept("./proceedingsTab.vue?vue&type=template&id=8061fa8e", function () {
      api.rerender('8061fa8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingsTab.vue"
export default component.exports